// components/Blocks/RelatedPersonForm.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import PhoneInput from '../../../../../../cabinet/wizplain/widgets/phone';

const RelatedPersonForm = ({ person, index, onChange, onRemove, editable, isViewOnly = false }) => {
  const handleChange = (field, value) => {
    if (isViewOnly) return;
    onChange(index, field, value);
  };

  const formatRnokpp = (val) => {
    const val_match = val.match(/[0-9]/g, '');
    return val_match && val_match.join("").slice(0,10) || '';
  };

  return (
    <div className="related-person-form border rounded p-3 mb-3 bg-light">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">Пов'язана особа #{index + 1}</h6>
        {editable && !isViewOnly && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() => onRemove(index)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        )}
      </div>
      
      <div className="row g-3 align-items-start">
        <div className="col-md-4">
          <div className="form-label">Прізвище</div>
          <input
            type="text"
            className="form-control"
            value={person.lastName || ''}
            onChange={(e) => handleChange('lastName', e.target.value)}
            placeholder="Введіть прізвище"
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-4">
          <div className="form-label">Ім'я</div>
          <input
            type="text"
            className="form-control"
            value={person.firstName || ''}
            onChange={(e) => handleChange('firstName', e.target.value)}
            placeholder="Введіть ім'я"
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-4">
          <div className="form-label">По батькові</div>
          <input
            type="text"
            className="form-control"
            value={person.middleName || ''}
            onChange={(e) => handleChange('middleName', e.target.value)}
            placeholder="Введіть по батькові"
            disabled={isViewOnly || !editable}
          />
        </div>

        <div className="col-md-6">
          <div className="form-label">Телефон</div>
          <PhoneInput 
            value={person.phone || ''}
            onChange={(e) => handleChange('phone', e.target.value)}
            disabled={isViewOnly || !editable}
          />
        </div>

        <div className="col-md-6">
          <div className="form-label">Дата народження</div>
          <input
            type="date"
            className="form-control"
            value={person.email || ''}
            onChange={(e) => handleChange('birthDate', e.target.value)}
            placeholder=""
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-6">
          <div className="form-label">E-mail</div>
          <input
            type="email"
            className="form-control"
            value={person.email || ''}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="Введіть email"
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-6">
          <div className="form-label">РНОКПП</div>
          <input
            type="text"
            className="form-control"
            placeholder="3495678801"
            value={person.taxNumber || ''}
            onChange={(e) => handleChange('taxNumber', formatRnokpp(e.target.value))}
            maxLength={10}
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-6">
          <div className="form-label">Громадянство</div>
          <select
            className="form-select"
            value={person.citizenship || ''}
            onChange={(e) => handleChange('citizenship', e.target.value)}
            disabled={isViewOnly || !editable}
          >
            <option value="">Оберіть громадянство</option>
            <option value="Україна">Україна</option>
            <option value="Інше">Інше</option>
          </select>
        </div>

        <div className="col-md-6">
          <div className="form-label">Адреса</div>
          <input
            type="text"
            className="form-control"
            value={person.address || ''}
            onChange={(e) => handleChange('address', e.target.value)}
            placeholder="Введіть адресу"
            disabled={isViewOnly || !editable}
          />
        </div>

        <div className="col-md-6">
          <div className="form-label">Viber</div>
          <input
            type="text"
            className="form-control"
            value={person.viber || ''}
            onChange={(e) => handleChange('viber', e.target.value)}
            placeholder="Введіть Viber"
            disabled={isViewOnly || !editable}
          />
        </div>
        
        <div className="col-md-6">
          <div className="form-label">Ступінь родової спорідненості</div>
          <select
            className="form-select"
            value={person.relationshipDegree || ''}
            onChange={(e) => handleChange('relationshipDegree', e.target.value)}
            disabled={isViewOnly || !editable}
          >
            <option value="">Оберіть ступінь</option>
            <option value="I ступінь">I ступінь</option>
            <option value="II ступінь">II ступінь</option>
            <option value="батько">Батько</option>
            <option value="мати">Мати</option>
            <option value="дід">Дід</option>
            <option value="баба">Баба</option>
            <option value="дядько">Дядько</option>
            <option value="тітка">Тітка</option>
            <option value="опікун">Опікун</option>
            <option value="інші">Інші</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default RelatedPersonForm;